import React, { useEffect, useState } from "react";
import { Router } from "utils";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { Loader } from "components";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3500);
    return () => clearTimeout(timer);
  });

  return (
    <>
      <BrowserRouter>
        {loading ? (
          <Loader />
        ) : (
          <Routes>
            {Router.map((route, index) => {
              const { path, Component, Layout } = route;
              const PageComponent = (
                <Layout>
                  <Component />
                </Layout>
              );
              return <Route key={index} path={path} element={PageComponent} />;
            })}
          </Routes>
        )}
      </BrowserRouter>
    </>
  );
}

export default App;
